export const showToast = (message, type = 'success') => {
    window.dispatchEvent(new CustomEvent('mywod-toast', { detail: { message, type } }));
};
